import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

import { hasPersistedBackendSession } from "../../services/persistedAuth";

function Private({ children, location }) {
  const rehydrated = useSelector((state) => state._persist?.rehydrated === true);
  const hasBackendFromStore = useSelector((state) =>
    Boolean(state.auth?.backendAccessToken ?? state.auth?.accessToken)
  );

  const [preHydrateBackendSession] = useState(hasPersistedBackendSession);

  const hasBackendSession = rehydrated
    ? hasBackendFromStore
    : preHydrateBackendSession;

  const isAuthenticated = useIsAuthenticated() || hasBackendSession;
  const { inProgress } = useMsal();

  if (inProgress !== "none") {
    return null;
  }

  return isAuthenticated ? (
    <Route render={(props) => React.cloneElement(children, props)} />
  ) : (
    <Redirect
      to={{
        pathname: "/",
        state: { from: location },
      }}
    />
  );
}

export default withRouter(Private);
